<div class="card mb-3">
  <div class="card-header">
    {{ 'components.state_card.title' | translate }}
  </div>
  <div class="card-body">
    <app-multi-select-enum
      name="state"
      [formControl]="control"
      label="{{ 'components.state_card.label' | translate }}"
      [multi]="false"
      placeholder="{{ 'components.state_card.label' | translate }}"
      [enum]="ModelStateEnum"
      translateKey="modelStateEnum"
      [sortByDisplayValue]="false"
      [omitValues]="omit"
      [errorMessages]="errorMessages"
    ></app-multi-select-enum>
    <ng-content></ng-content>
  </div>
</div>
